import { module } from "app/user/module.const";
import { role, roleDefinition } from "../../user/role.const";
import { RoleMenuItem } from "./navigation.service";

export const settingsLabel = "Settings";

export const userDropdown: RoleMenuItem[] = [
  {
    label: "Profile",
    icon: "pi pi-user",
    callback: "openProfile",
    roles: roleDefinition.user,
  },
  {
    label: "Logout",
    icon: "pi pi-power-off",
    routerLink: "logout",
    roles: roleDefinition.user,
  },
  {
    label: "Exit",
    icon: "pi pi-sign-in",
    routerLink: "exit",
    roles: roleDefinition.previousAdmin,
  },
];

export const mainMenu: RoleMenuItem[] = [
  {
    label: "Quotes",
    icon: "pi pi-file",
    routerLink: "quote/list",
    roles: roleDefinition.readOnly.concat(roleDefinition.sales),
  },
  {
    label: "CRM",
    icon: "pi pi-users",
    roles: roleDefinition.readOnly.concat(roleDefinition.sales),
    items: [
      {
        label: "Accounts",
        routerLink: `client/list`,
        roles: roleDefinition.readOnly.concat(roleDefinition.sales),
      },
      {
        label: "Activities",
        routerLink: `activity`,
        roles: roleDefinition.readOnly.concat(roleDefinition.sales),
        module: module.crm,
      },
      {
        label: "Potential",
        routerLink: `potential/list`,
        roles: roleDefinition.readOnly.concat(roleDefinition.sales),
        module: module.crm,
      },
    ],
  },
  {
    label: "Rates",
    icon: "pi pi-table",
    routerLink: `rate/list`,
    roles: roleDefinition.readOnly.concat(roleDefinition.sales),
  },
  {
    label: "Locations",
    icon: "pi pi-map-marker",
    roles: roleDefinition.pricingManager.concat([role.superAdmin]),
    items: [
      {
        label: "Charges",
        routerLink: `location/list`,
        roles: roleDefinition.pricingManager.concat([role.superAdmin]),
      },
      {
        label: "Groups",
        routerLink: `location-group/list`,
        roles: roleDefinition.pricingManager.concat([role.superAdmin]),
      },
      {
        label: "Countries",
        routerLink: `country/list`,
        roles: roleDefinition.pricingManager.concat([role.superAdmin]),
      },
    ],
  },
  {
    label: settingsLabel,
    icon: "pi pi-sliders-h",
    roles: roleDefinition.pricingManager.concat([role.superAdmin]),
    items: [
      {
        label: "Carriers",
        routerLink: "carrier/list",
        roles: roleDefinition.superAdmin,
      },
      {
        label: "Notifications",
        routerLink: "notification/list",
        roles: roleDefinition.superAdmin,
      },
      {
        label: "Margins",
        routerLink: `tier/list`,
        roles: roleDefinition.pricingManager.concat([role.superAdmin]),
      },
      {
        label: "Margin Machine",
        routerLink: `margin-rule/list`,
        roles: roleDefinition.readOnly.concat(roleDefinition.superAdmin),
        module: module.marginMachine,
      },
      {
        label: "Surcharge types",
        routerLink: `surcharge-type/list`,
        roles: roleDefinition.pricingManager.concat([role.superAdmin]),
      },
      {
        label: "Holidays",
        routerLink: "holiday/list",
        roles: roleDefinition.pricingManager.concat([role.superAdmin]),
      },
      {
        label: "Organizations",
        routerLink: "organization/list",
        roles: roleDefinition.superAdmin,
      },
      {
        label: "My Organization",
        icon: "pi pi-id-card",
        callback: "openOrganizationForm",
        roles: roleDefinition.organizationAdmin,
      },
      {
        label: "Terms and Conditions",
        icon: "pi pi-file",
        callback: "openOrganizationTermsList",
        roles: roleDefinition.organizationAdmin,
      },
      {
        label: "Teams",
        routerLink: "team/list",
        roles: roleDefinition.organizationAdmin.concat([role.superAdmin]),
      },
      {
        label: "Companies",
        routerLink: "company/list",
        roles: roleDefinition.organizationAdmin.concat([role.superAdmin]),
      },
      {
        label: "Users",
        routerLink: "user/list",
        roles: roleDefinition.pricingManager.concat([role.superAdmin]),
      },
    ],
  },
];
